import gql from 'graphql-tag';

export const ARTIFACT_COLLECTION_OVERVIEW_QUERY = gql`
  query ArtifactCollectionOverview(
    $artifactCollectionID: ID!
  ) {
    artifactCollection(id: $artifactCollectionID) {
      id
      __typename
      name
      defaultArtifactType {
        id
        name
      }
      versionIndexes
      aliases {
        edges {
          node {
            id
            alias
          }
        }
      }
      project {
        id
        name
        entity {
          id
          name
        }
      }
    }
  }
`;
